<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">企微会话记录 / AI质检</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <FilterCommon ref="filterCommon" :model="model" :isReset="true" @search="search" @reset="reset"></FilterCommon>

        <div class="card">
          <div class="tab-bar">
            <el-radio-group v-model="activeTab" size="small" @change="handleTabChange">
              <el-radio-button v-for="tabItem in options.tabs" :key="tabItem.value" :label="tabItem.value">{{ tabItem.label }}</el-radio-button>
            </el-radio-group>
            <div class="tab-actions">
              <el-button type="primary" size="small" v-if="showBatchConfirm" @click="batchOperate('batch_confirm')">批量确认</el-button>
              <el-button size="small" v-if="showBatchRemindOnly" @click="batchOperate('batch_remind_only')">批量仅提醒</el-button>
              <el-button type="danger" size="small" v-if="showBatchFalseHit" @click="batchOperate('batch_false_hit')">批量误报</el-button>
              <el-button type="info" size="small" v-if="showBatchNoAction" @click="batchOperate('batch_no_action')">批量无需处理</el-button>
              <el-button type="primary" size="small" v-if="showBatchAppealPass" @click="batchOperate('batch_appeal_pass')">批量审核通过</el-button>
              <el-button type="danger" size="small" v-if="showBatchAppealReject" @click="batchOperate('batch_appeal_reject')">批量审核驳回</el-button>
              <el-button type="primary" size="small" v-if="options.canManageTimelinessRule" @click="openTimelinessRule">时效质检规则</el-button>
              <el-button type="success" size="small" v-if="options.canManageFeishuAlertPolicy" @click="openFeishuAlertPolicy">飞书预警策略</el-button>
              <el-button type="warning" size="small" v-if="activeTab === 'done'" @click="openWecomPolicy">企微报警策略</el-button>
              <el-button size="small" @click="refreshOwner">刷新地区/负责客服</el-button>
            </div>
          </div>

          <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" />
            <el-table-column prop="hit_time" label="命中时间" width="160" />
            <el-table-column prop="quality_type_name" label="质检类型" width="100" />
            <el-table-column label="标签" width="180">
              <template slot-scope="scope">
                <el-tag v-for="item in scope.row.labels" :key="item.label" size="mini" :type="labelTagType(item.label)" style="margin: 2px">{{ item.label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="corp_name" label="主体" width="90" />
            <el-table-column prop="contact_name" label="企微客服" width="140" />
            <el-table-column label="负责客服" width="90">
              <template slot-scope="scope">{{ scope.row.responsible_admin_name || '—' }}</template>
            </el-table-column>
            <el-table-column label="地区" width="90">
              <template slot-scope="scope">{{ scope.row.city_name || '—' }}</template>
            </el-table-column>
            <el-table-column label="客户信息" min-width="140">
              <template slot-scope="scope">
                <div class="ellipsis" :title="scope.row.external_remark || scope.row.external_name">{{ scope.row.external_remark || scope.row.external_name }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用户名" min-width="130">
              <template slot-scope="scope">{{ scope.row.bind_user_name || '—' }}</template>
            </el-table-column>
            <el-table-column label="子游戏名称" min-width="130">
              <template slot-scope="scope">{{ scope.row.sub_game_name || '—' }}</template>
            </el-table-column>
            <el-table-column label="账号总充值" width="130" align="right">
              <template slot-scope="scope">{{ formatCurrency(scope.row.account_total_recharge) }}</template>
            </el-table-column>
            <el-table-column label="角色充值" width="130" align="right">
              <template slot-scope="scope">{{ formatCurrency(scope.row.role_recharge) }}</template>
            </el-table-column>
            <el-table-column prop="quality_msg_time" label="质检消息时间" width="160" />
            <el-table-column label="回复间隔" width="100">
              <template slot-scope="scope">{{ showReplyInterval(scope.row.labels) ? scope.row.reply_interval_text : '—' }}</template>
            </el-table-column>
            <el-table-column label="处理状态" width="100">
              <template slot-scope="scope"><el-tag size="mini" :type="statusTagType(scope.row.status)">{{ scope.row.status_name }}</el-tag></template>
            </el-table-column>
            <el-table-column label="操作" width="280" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="openDrawer(scope.row.id)">详情</el-button>
                <el-button type="text" v-for="op in visibleOperations(scope.row)" :key="op" @click="openOperation(op, scope.row.id)">{{ operationButtonText(op) }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-pagination">
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
          </div>
        </div>

        <Drawer ref="drawer" :options="options" @refresh="getList" @operate="openOperation"></Drawer>
        <OperationDialog ref="opDialog" @success="handleOperationSuccess"></OperationDialog>
        <WecomPolicyDialog ref="wecomPolicy" :options="options"></WecomPolicyDialog>
        <TimelinessRuleDialog ref="timelinessRule"></TimelinessRuleDialog>
        <FeishuAlertPolicyDialog ref="feishuAlertPolicy" :options="options"></FeishuAlertPolicyDialog>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import FilterCommon from '@/components/common/Filter';
import Pagination from '@/components/pagination/index';
import Drawer from './component/Drawer.vue';
import OperationDialog from './component/OperationDialog.vue';
import WecomPolicyDialog from './component/WecomPolicyDialog.vue';
import TimelinessRuleDialog from './component/TimelinessRuleDialog.vue';
import FeishuAlertPolicyDialog from './component/FeishuAlertPolicyDialog.vue';
import { getQwAiQualityOptionsApi, getQwAiQualityListApi, refreshOwnerQwAiQualityApi } from '@/api/qwAiQuality';
import { STATUS_TAG_TYPE, OPERATION_BUTTON_TEXT, labelTagType, shouldShowReplyInterval, filterVisibleOperations, normalizeQwAiQualityOptions } from './constants';

// 筛选项是页面级共用的：切换 Tab 只刷新列表和操作列，不清空已选的筛选条件（对齐 PRD 的 Tab 切换行为约定）
export default {
  components: { FilterCommon, Pagination, Drawer, OperationDialog, WecomPolicyDialog, TimelinessRuleDialog, FeishuAlertPolicyDialog },
  data() {
    const today = dayjs().format('YYYY-MM-DD');
    return {
      options: {},
      activeTab: '',
      listLoading: false,
      tableData: [],
      total: 0,
      selectArr: [],
      listQuery: {
        page: 1,
        limit: 10,
        hit_time_start: today,
        hit_time_end: today,
      },
    };
  },
  computed: {
    model() {
      return [
        {
          type: 'select', label: '单双号', key: 'account_type', clearable: true, span: 6,
          options: [{ value: 'single', label: '单号' }, { value: 'double', label: '双号' }],
        },
        {
          type: 'date-picker',
          label: '命中时间',
          key: 'hit_time',
          dateType: false,
          pick: true,
          showDefault: true,
          span: 6,
        },
        {
          type: 'select',
          label: '主体',
          key: 'corpid',
          placeholder: '请选择主体，支持多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.corps,
        },
        {
          type: 'select',
          label: '地区',
          key: 'city_names',
          placeholder: '请选择地区',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.cities,
        },
        {
          type: 'select',
          label: '企微客服',
          key: 'contact_userids',
          placeholder: '支持模糊搜索，多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.contacts,
        },
        {
          type: 'select',
          label: '负责客服',
          key: 'responsible_admin_ids',
          placeholder: '支持模糊搜索，多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.admins,
        },
        {
          type: 'input',
          label: '客户信息',
          key: 'external_keyword',
          placeholder: '昵称/备注模糊搜索',
          span: 6,
        },
        {
          type: 'select',
          label: '标签',
          key: 'labels',
          placeholder: '请选择标签',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.labels,
        },
        {
          type: 'select',
          label: '质检状态',
          key: 'statuses',
          placeholder: '请选择状态',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.statuses,
        },
      ];
    },
    showBatchConfirm() {
      return this.activeTab === 'pending' && this.hasOperation('confirm');
    },
    showBatchRemindOnly() {
      return this.activeTab === 'pending' && this.hasOperation('remind_only');
    },
    showBatchFalseHit() {
      return this.activeTab === 'pending' && this.hasOperation('false_hit');
    },
    showBatchNoAction() {
      return this.activeTab === 'pending' && this.hasOperation('no_action');
    },
    showBatchAppealPass() {
      return this.activeTab === 'appeal' && this.hasOperation('appeal_pass');
    },
    showBatchAppealReject() {
      return this.activeTab === 'appeal' && this.hasOperation('appeal_reject');
    },
  },
  created() {
    this.getOptions();
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '—'
      const amount = Number(value)
      if (Number.isNaN(amount)) return '—'
      return '¥' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    async getOptions() {
      const data = await getQwAiQualityOptionsApi({
        types: 'tab,label,status,city,corp,contact,admin,operation',
      });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.options = normalizeQwAiQualityOptions(data.data);
      if (this.options.tabs.length) {
        this.activeTab = this.options.tabs[0].value;
        this.listQuery.tab = this.activeTab;
        this.applyRouteFilters();
        this.getList();
      }
    },
    applyRouteFilters() {
      const routeQuery = this.$route.query || {};
      const responsibleAdminIds = this.parseNumberList(routeQuery.responsible_admin_ids);
      const statuses = this.parseNumberList(routeQuery.statuses);
      const labels = this.parseStringList(routeQuery.labels);
      const hitTimeStart = routeQuery.hit_time_start;
      const hitTimeEnd = routeQuery.hit_time_end;
      const feishuAlert = routeQuery.feishu_alert === '1' ? 1 : 0;
      const accountType = ['single', 'double'].indexOf(routeQuery.account_type) !== -1 ? routeQuery.account_type : '';
      const statsStartAt = feishuAlert ? routeQuery.stats_start_at || '' : '';
      if (!responsibleAdminIds.length && !statuses.length && !labels.length && !hitTimeStart && !hitTimeEnd && !feishuAlert && !accountType) return;

      const allTab = (this.options.tabs || []).find(item => item.value === 'all');
      if (allTab) {
        this.activeTab = allTab.value;
        this.listQuery.tab = allTab.value;
      }

      this.listQuery = Object.assign({}, this.listQuery, {
        responsible_admin_ids: responsibleAdminIds,
        labels,
        statuses,
        feishu_alert: feishuAlert,
        account_type: accountType,
        stats_start_at: statsStartAt,
        hit_time_start: hitTimeStart || this.listQuery.hit_time_start,
        hit_time_end: hitTimeEnd || this.listQuery.hit_time_end,
      });
      this.$nextTick(() => {
        if (!this.$refs.filterCommon) return;
        this.$refs.filterCommon.formData = {
          responsible_admin_ids: responsibleAdminIds,
          labels,
          statuses,
          account_type: accountType,
          hit_time: [this.listQuery.hit_time_start, this.listQuery.hit_time_end],
          start_date: this.listQuery.hit_time_start,
          end_date: this.listQuery.hit_time_end,
        };
      });
    },
    parseNumberList(value) {
      return this.parseStringList(value).map(item => Number(item)).filter(item => Number.isInteger(item) && item > 0);
    },
    parseStringList(value) {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (!value) return [];
      return String(value).split(',').map(item => item.trim()).filter(Boolean);
    },
    handleTabChange(tab) {
      this.selectArr = [];
      this.listQuery.tab = tab;
      this.listQuery.page = 1;
      this.getList();
    },
    async getList() {
      this.listLoading = true;
      const data = await getQwAiQualityListApi(this.listQuery);
      this.listLoading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
    },
    search(formData) {
      const query = Object.assign({}, formData);
      const today = dayjs().format('YYYY-MM-DD');
      query.hit_time_start = formData.start_date || today;
      query.hit_time_end = formData.end_date || today;
      delete query.hit_time;
      delete query.start_date;
      delete query.end_date;
      this.listQuery = Object.assign({ tab: this.activeTab, page: 1, limit: this.listQuery.limit }, query,
        { feishu_alert: this.listQuery.feishu_alert, stats_start_at: this.listQuery.stats_start_at });
      this.getList();
    },
    reset() {
      const today = dayjs().format('YYYY-MM-DD');
      this.listQuery = {
        tab: this.activeTab,
        page: 1,
        limit: this.listQuery.limit,
        feishu_alert: this.listQuery.feishu_alert,
        stats_start_at: this.listQuery.stats_start_at,
        hit_time_start: today,
        hit_time_end: today,
      };
      this.getList();
    },
    handleSelectionChange(rows) {
      this.selectArr = rows.map(item => item.id);
    },
    openDrawer(id) {
      this.$refs.drawer.open(id);
    },
    openOperation(type, id) {
      this.$refs.opDialog.open(type, id);
    },
    batchOperate(type) {
      if (!this.selectArr.length) {
        this.$message.error('请先勾选要操作的数据');
        return;
      }
      this.$refs.opDialog.open(type, this.selectArr);
    },
    openWecomPolicy() {
      this.$refs.wecomPolicy.open();
    },
    openTimelinessRule() {
      this.$refs.timelinessRule.open();
    },
    openFeishuAlertPolicy() {
      this.$refs.feishuAlertPolicy.open();
    },
    async refreshOwner() {
      if (!this.selectArr.length) {
        this.$message.error('请先勾选要刷新的数据');
        return;
      }
      const data = await refreshOwnerQwAiQualityApi({ ids: this.selectArr });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      const failedCount = (data.data.failed || []).length;
      this.$message.success(failedCount ? `刷新完成，${failedCount} 条未匹配到负责客服` : '刷新成功');
      this.getList();
    },
    handleOperationSuccess() {
      this.selectArr = [];
      this.getList();
      // 操作可能是从详情抽屉里发起的，抽屉还开着就同步刷新它的详情和可用操作
      this.$refs.drawer.refreshDetail();
    },
    hasOperation(op) {
      return (this.options.operations || []).some(item => item.value === op);
    },
    visibleOperations(row) {
      return filterVisibleOperations(row.available_operations, this.options.operations);
    },
    statusTagType(status) {
      return STATUS_TAG_TYPE[status] || 'info';
    },
    labelTagType,
    showReplyInterval: shouldShowReplyInterval,
    operationButtonText(op) {
      return OPERATION_BUTTON_TEXT[op] || op;
    },
  },
};
</script>

<style scoped>
.card {
  background: #fff;
  border: 1px solid #dfe4ec;
  border-radius: 4px;
  padding: 0;
}
.tab-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 0;
  margin-bottom: 16px;
}
.tab-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.table-pagination {
  padding: 16px 20px;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
